import React from 'react';
import PropTypes from 'prop-types';

import { KeepAspectRatio, DynamicPlayerBadge } from '../..';
import { BLACK } from '../../styles/shared/colors';
import createDurationFromSeconds from '../../utils/createDurationFromSeconds';
import "./HighlightPreview.scss";

const HighlightPreview = ({ highlight, onClick })=> {
  const { thumbnailUri, sender, seekTime, title } = highlight;
  const { avatar, avatarBgColor, firstName, lastName } = sender || {};

  const handleClick = () => {
    onClick(highlight);
  };

  return (
    <div className="highlight-preview">
      <KeepAspectRatio adjustAcordingToWidth>
        <button className="highlight-preview__button" onClick={handleClick}>
          <img className="highlight-preview__button__image" src={thumbnailUri} />
        </button>
      </KeepAspectRatio>
      <div className="highlight-preview__footer">
        <DynamicPlayerBadge 
          avatar={avatar} 
          firstName={firstName} 
          lastName={lastName} 
          avatarBgColor={avatarBgColor || BLACK}
          badgeSize={45}
        />
        <span className="highlight-preview__footer__time">{createDurationFromSeconds(seekTime)}</span>
        <span className="highlight-preview__footer__title">{title}</span>
      </div>
    </div>  
  );
};

HighlightPreview.propTypes = {
  highlight: PropTypes.object,
  onClick: PropTypes.func
};

HighlightPreview.defaultProps = {
  highlight: {}, 
  onClick: () => {}
};

export default HighlightPreview;